import React, { useCallback } from 'react';
import { Link as RouterLink, useHistory, useLocation } from 'react-router-dom';
import { useTheme, useMediaQuery, Typography, Button, IconButton } from '@material-ui/core';
import LeftArrowLg from '€icons/LeftArrowLg';
import LeftArrow from '€icons/LeftArrow';
import { LocationState } from '../../types';
import { Hidden } from '€components/Hidden';

type PageHeaderBackLinkProps = {
    path: string;
    text?: string;
    isHistory?: boolean;
};

const PageHeaderBackLink = ({ isHistory, path, text }: PageHeaderBackLinkProps) => {
    const theme = useTheme();
    const { state: locationState } = useLocation<LocationState>();
    const matches = useMediaQuery(theme.breakpoints.up('sm'));
    const history = useHistory();
    const handleClick = useCallback(() => {
        history.go(-1);
    }, [history]);

    return (
        <>
            <Hidden xsDown>
                <Typography component="div" variant="subtitle2" style={{ whiteSpace: 'nowrap' }}>
                    <Button
                        component={RouterLink}
                        to={
                            !isHistory && {
                                pathname: path,
                                state: {
                                    path: locationState?.path || '',
                                },
                            }
                        }
                        onClick={isHistory && handleClick}
                        startIcon={
                            matches ? (
                                <LeftArrowLg data-testid="large-arrow" />
                            ) : (
                                <LeftArrow data-testid="small-arrow" />
                            )
                        }
                        style={{ font: 'inherit' }}
                        size="small"
                    >
                        {text}
                    </Button>
                </Typography>
            </Hidden>
            <Hidden smUp>
                <Typography
                    variant="subtitle2"
                    component={RouterLink}
                    color="textPrimary"
                    to={path}
                    style={{ textDecoration: 'none' }}
                >
                    <IconButton color="inherit" style={{ padding: 0, verticalAlign: 'bottom' }}>
                        {matches ? (
                            <LeftArrowLg data-testid="large-arrow" />
                        ) : (
                            <LeftArrow data-testid="small-arrow" />
                        )}
                    </IconButton>
                    {text}
                </Typography>
            </Hidden>
        </>
    );
};

export default PageHeaderBackLink;
